import { Autocomplete, TextField } from "@mui/material";
import { useGridApiContext } from "@mui/x-data-grid";
import { memo, useEffect, useState } from "react";
import UnidadeArmazenamentoDataSet from "../data/UnidadeArmazenamentoDataSet";
import UnidadeArmazenamento from "../classes/UnidadeArmazenamento";
import { hasInCache } from "../../helper/cacheHelper";
import { useTranslation } from "react-i18next";

function AutocompleteSKUMateriaPrima(props: any) {
  const { t } = useTranslation();
  const { id, value, field } = props;
  const apiRef = useGridApiContext();
  const dataSet = new UnidadeArmazenamentoDataSet();
  const [data, setData] = useState<UnidadeArmazenamento[]>([]);
  const [dataFilter, setDataFilter] = useState<UnidadeArmazenamento[]>([]);
  const [autoCompleteValue, setAutoCompleteValue] = useState<
    string | undefined
  >("");
  const [autoCompleteInputValue, setAutoCompleteInputValue] = useState("");

  useEffect(() => {
    const materiaPrimaCache: string = String(
      localStorage.getItem("MateriaPrimaCache")
    );
    if (materiaPrimaCache && materiaPrimaCache !== 'null') {
      const data: UnidadeArmazenamento[] = JSON.parse(
        materiaPrimaCache
      );
      if (data) {
        setData(data);
        setAutoCompleteData(data);
      }
    } else {
      dataSet.ListarMateriasPrimas().then((result) => {
        if (result) {
          setData(result);
          setAutoCompleteData(result);
          localStorage.setItem("MateriaPrimaCache", JSON.stringify(result));
        }
      });
    }

    function setAutoCompleteData(data: UnidadeArmazenamento[]) {
      if (data && id) {
        const row = apiRef.current.getRow(id);
        if (row) {
          let tempIdSku: number | null = null;
          if (field === "skuSolicitado") {
            tempIdSku = row.idSkuSolicitado;
          } else if (field === "skuProposto") {
            tempIdSku = row.idSkuProposto;
          } else if (field === "skuEntregue") {
            tempIdSku = row.idSkuEntregue;
          }
          if (tempIdSku) {
            const skuFound: UnidadeArmazenamento | undefined = data.find(
              (f) => f.idSKU === tempIdSku
            );
            if (skuFound) {
              setAutoCompleteValue(
                String(skuFound.idSKU) + " - " + skuFound.descricao
              );
            }
          }
        }
      }
    }
  }, []);

  useEffect(() => {
    if (data && data.length > 0 && id) {
      const row = apiRef.current.getRow(id);
      if (row) {
        const tempIdSku = row.idSkuSolicitado
          ? row.idSkuSolicitado
          : row.idSkuEntregue
          ? row.idSkuEntregue
          : null;
        if (tempIdSku) {
          setDataFilter(data.filter((f) => f.idSKU === tempIdSku));
        }
      }
    }
  }, [data]);

  useEffect(() => {
    if (
      dataFilter !== null &&
      dataFilter !== undefined &&
      dataFilter.length === 1
    ) {
      localStorage.setItem("SKUSel", String(dataFilter[0].idSKU));
      const cellValue = {
        id,
        field,
        value: String(dataFilter[0].idSKU),
      };
      if (cellValue.field === "skuSolicitado") {
        cellValue.field = "idSkuSolicitado";
      }
      if (cellValue.field === "skuProposto") {
        cellValue.field = "idSkuProposto";
      }
      if (cellValue.field === "skuEntregue") {
        cellValue.field = "idSkuEntregue";
      }
      apiRef.current.setEditCellValue(cellValue);
      apiRef.current.commitCellChange(cellValue);
    } else if (dataFilter.length !== 1) localStorage.removeItem("SKUSel");
  }, [dataFilter]);

  const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDataFilter(
      data.filter((f) => f.idSKU.toString().startsWith(event.target.value))
    );
  };

  const handlerAutocompleteOnChange = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string | undefined
  ) => {
    setDataFilter(
      data.filter(
        (f) =>
          f.idSKU.toString() + " - " + f.descricao ===
          String(event.currentTarget.textContent)
      )
    );
  };

  return (
    <>
      <Autocomplete
        value={autoCompleteValue}
        inputValue={autoCompleteInputValue}
        onInputChange={(_event, newInputValue) => {
          setAutoCompleteInputValue(newInputValue);
        }}
        fullWidth
        size="small"
        freeSolo
        id="autoCompleteSku"
        disableClearable
        options={data.map(
          (option: any) => option.idSKU + " - " + option.descricao
        )}
        onChange={handlerAutocompleteOnChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t("common.autoComplete.listaTecnica.label")}
            InputProps={{
              ...params.InputProps,
              type: "search",
            }}
            onChange={handlerOnChange}
          />
        )}
      />
    </>
  );
}

interface AutocompleteSKUProps {
  id: number;
  value: string;
  field: string;
}

export default memo(AutocompleteSKUMateriaPrima);
